import { Badge } from "@/components/ui/badge";

const EnterpriseTrust = () => {
  const industries = [
    "SaaS & Technology",
    "Professional Services",
    "Financial Services",
    "Manufacturing",
  ];



  return (
    <section className="py-12 md:py-16 bg-background border-y border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">

          {/* Industries */}
          <div className="text-center mb-10">
            <p className="text-sm text-muted-foreground mb-4">Trusted by B2B companies in:</p>
            <div className="flex flex-wrap justify-center gap-3">
              {industries.map((industry, index) => (
                <Badge 
                  key={index} 
                  variant="outline" 
                  className="px-4 py-1.5 text-sm bg-secondary/5 border-secondary/20"
                >
                  {industry}
                </Badge>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default EnterpriseTrust;
